import { axiosTokenInstance } from 'src/utils/axiosInstance.utils';
import { apiUrls } from 'src/utils/properties.utils';

export const fetchEnums = async () => {
  const response = await axiosTokenInstance.get(apiUrls.GET_ENUMS);
  return response.data;
};

export const fetchRawMaterialUnits = async () => {
  const response = await axiosTokenInstance.get(apiUrls.GET_RAW_MATERIAL_UNITS);
  return response.data;
};

export const fetchProductUnits = async () => {
  const response = await axiosTokenInstance.get(apiUrls.GET_PRODUCT_UNITS);
  return response.data;
};

export const fetchBankNames = async () => {
  const response = await axiosTokenInstance.get(apiUrls.GET_BANK_NAMES);
  return response.data;
};
